<div class="border-grey-3 py-xs flex w-full items-center justify-between border-b bg-white px-6">
  <div class="paragraph-medium-medium flex flex-1 items-center gap-2 text-center">
    <a [routerLink]="['/']" hlmBtn variant="ghost">
      <ng-icon hlm name="lucideHouse" size="sm" />
      {{ cartographieCourante()?.nom ?? 'Cartographie non définie' }}
    </a>

    @if (displayReferentiel() && referentiel(); as referentiel) {
      <span>•</span>
      <span class="px-2">{{ referentiel.nom }}</span>
    }

    @if (screenTitle(); as title) {
      <span>•</span>
      <span class="px-2">{{ title }}</span>
    }

    <ng-content />
  </div>

  <app-help-button />
  <app-user-menu />
</div>
